import React from 'react';
import { useHistory } from 'react-router-dom';
import StripeElementsProvider from "../../providers/StripeElementsProvider";
import { FullPageModal, FullPageModalHeaderStart, Typography } from 'seagull';
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
import { useStore, useStoreActions } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { routes } from "../../constants";
import { wait } from "../../infra/utils";
import FullPageInvoiceWithData from "./FullPageInvoiceWithData";
import styles from "./FullPageInvoice.module.scss";
import { useRequestPM } from "../../hooks/useRequestPaymentMethod";
import FeatureFlagsRelationshipContext from "../FeatureFlagsRelationshipContext";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
export default function FullPageInvoice(props) {
  const {
    invoiceId,
    relationshipId,
    dismissModal,
    onRefresh
  } = props;
  const {
    api
  } = useStoreActions();
  const {
    USE_INVOICE_VIEWS = false
  } = useFeatureFlags();
  const isVendor = useStore(selectors.user.isVendor);
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const showInvoiceQboSection = useStore(selectors.integration.showInvoiceQboSection);
  const history = useHistory();
  const onRequestPM = useRequestPM();
  const fetch = async () => {
    if (!invoiceId || !relationshipId) {
      throw new Error('missing data');
    }
    const [invoice, relationship] = await Promise.all([USE_INVOICE_VIEWS ? api.invoice.getByIDScout(invoiceId, !isVendor) : api.invoice.getByID(invoiceId, !isVendor), api.relationship.get(relationshipId)]);
    const integratedInvoice = showInvoiceQboSection ? await api.invoice.integrationDetails(invoiceId, invoice.isZeroAmount) : null;
    return {
      relationship,
      invoice,
      integratedInvoice
    };
  };
  return /*#__PURE__*/React.createElement(FullPageModal, {
    showFooter: true,
    "data-testid": "fpi",
    onClose: () => dismissModal()
  }, /*#__PURE__*/React.createElement(StripeElementsProvider, null, /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: fetch,
    renderChild: _ref => {
      let {
        data,
        refresh
      } = _ref;
      return /*#__PURE__*/React.createElement(FeatureFlagsRelationshipContext, {
        vendorId: data.relationship.vendor.id
      }, /*#__PURE__*/React.createElement(FullPageInvoiceWithData, {
        invoice: data.invoice,
        integratedInvoice: data.integratedInvoice,
        relationship: data.relationship,
        showQboIntegration: showQboIntegration,
        showInvoiceQboSection: showInvoiceQboSection,
        isVendor: isVendor,
        onRefresh: onRefresh,
        refresh: refresh,
        onRedirectToPaymentMethods: async () => {
          dismissModal();
          await wait(0);
          history.push(routes.paymentMethods(data.relationship.id));
        },
        onRequestPaymentMethod: async () => {
          if (relationshipId != null) await onRequestPM(relationshipId);
        }
      }));
    },
    renderError: () => /*#__PURE__*/React.createElement("div", {
      className: styles.error,
      "data-testid": "fpi-error"
    }, /*#__PURE__*/React.createElement(FullPageModalHeaderStart, null, "Error"), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "This invoice could not be loaded. Please try again later."))
  })));
}